import { Outlet } from 'react-router-dom';

const Wrapper: React.FC = () => <Outlet />;

export default Wrapper;
